import {
  BwArrowDownMdLine,
  BwArrowUpDownLine,
  BwArrowUpMdLine,
} from "@/components/ui/icons";
import type { Column } from "@/components/ui/table/table-features";
import { useSortParam } from "./_hooks/use-sort-param";

type SortableHeaderProps = {
  column: Column<any>;
  label: string;
  sortable?: boolean;
};

/**
 * Drop-in replacement for the shared `HeaderColumn` that writes the canonical
 * `sort=-field` STRING to the URL (the query-params standard) instead of the
 * deprecated object-shaped `sorts` the legacy `HeaderColumn` still emits. Used
 * by admin list tables; the field name is the react-table `column.id` (which
 * must match the API sort field). Rendering mirrors `HeaderColumn` exactly.
 */
export const SortableHeader = ({
  column,
  label,
  sortable,
}: SortableHeaderProps) => {
  const { directionFor, toggle } = useSortParam();
  const field = column?.id as string;
  const direction = directionFor(field);

  return (
    <div
      className="flex items-center space-x-2 text-sm font-medium leading-5 text-text-dark-high"
      onClick={() => sortable && toggle(field)}
    >
      <span>{label}</span>
      {sortable && (
        <>
          {!direction && (
            <BwArrowUpDownLine size={16} className="cursor-pointer" />
          )}
          {direction === "asc" && (
            <BwArrowDownMdLine size={16} className="cursor-pointer" />
          )}
          {direction === "desc" && (
            <BwArrowUpMdLine size={16} className="cursor-pointer" />
          )}
        </>
      )}
    </div>
  );
};
